import React from "react";
import { Col, Row } from "react-bootstrap";
import LoadSkirts from "../../../components/load-skirts/LoadSkirts"

const LoadSkirtsView = () => {
  return (
    <Row>
      <Col col={12} className="col-12 mb-3">
        <LoadSkirts />
      </Col>
    </Row>
  );
};

export default LoadSkirtsView;
